import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import OrderQuery from '../views/OrderQuery.vue'
import OrderDetail from '../views/OrderDetail.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/order-query',
      name: 'OrderQuery',
      component: OrderQuery
    },
    {
      path: '/order-detail',
      name: 'OrderDetail',
      component: OrderDetail
    }
  ]
})